var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.multi
    ? _c("w-select", {
        attrs: {
          items: _vm.folders,
          label: _vm.label,
          value: _vm.singleItemValue,
        },
        on: {
          input: function ($event) {
            return _vm.setSingleItemValue($event)
          },
        },
      })
    : _c("w-multi-select", {
        attrs: {
          items: _vm.folders,
          label: _vm.label,
          value: _vm.multiItemValue,
        },
        on: {
          input: function ($event) {
            return _vm.setMultiItemValue($event)
          },
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }